import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';

const CHATBOT_CONFIG = {
  alwaysIncludedDealIds: [],
  containerId: 'shop-dev-container',
  excludedDealIds: [],
  excludedRoutes: ['/checkout', '/my-account', '/guides'],
};

const ChatbotContainer = () => {
  const router = useRouter();
  const [shouldShowChatbot, setShouldShowChatbot] = useState(false);
  const chatbotInitialized = useRef(false);
  const currentChatbotState = useRef(false);

  // Check if current page should show chatbot
  const checkChatbotVisibility = () => {
    const currentPath = router.asPath;
    const { query } = router;

    const dealIdMatch = currentPath.match(/\/deal\/([^/?]+)/);
    const dealId = dealIdMatch ? dealIdMatch[1] : query.dealId || query.id;

    if (
      dealId &&
      CHATBOT_CONFIG.alwaysIncludedDealIds.includes(dealId.toString())
    ) {
      console.log(`Chatbot forced to show for always-included deal: ${dealId}`);

      return true;
    }

    const isDealPage =
      currentPath.includes('/deal/') ||
      currentPath.includes('/deals/') ||
      router.pathname.includes('/deal');

    if (!isDealPage) return false;

    const isExcludedRoute = CHATBOT_CONFIG.excludedRoutes.some((route) =>
      currentPath.includes(route),
    );
    if (isExcludedRoute) return false;

    if (dealId && CHATBOT_CONFIG.excludedDealIds.includes(dealId.toString())) {
      return false;
    }

    return true;
  };

  // Hide chatbot manually
  const hideChatbot = () => {
    try {
      const chatbotWrapper = document.querySelector('#chatbot-wrapper');
      if (chatbotWrapper) {
        chatbotWrapper.style.display = 'none';
        console.log('Chatbot hidden via wrapper');
      }

      // if (window.chatbot) {
      //   if (typeof window.chatbot.hide === 'function') {
      //     window.chatbot.hide();
      //   } else if (typeof window.chatbot.close === 'function') {
      //     window.chatbot.close();
      //   } else if (typeof window.chatbot.destroy === 'function') {
      //     window.chatbot.destroy();
      //   }
      // }

      // if (window.ShopDevChatbot) {
      //   if (typeof window.ShopDevChatbot.hide === 'function') {
      //     window.ShopDevChatbot.hide();
      //   }
      // }

      currentChatbotState.current = false;
    } catch (error) {
      console.error('Error hiding chatbot:', error);
    }
  };

  // Show chatbot manually
  const showChatbot = () => {
    try {
      const chatbotWrapper = document.querySelector('#chatbot-wrapper');
      if (chatbotWrapper) {
        chatbotWrapper.style.display = 'block';
        console.log('Chatbot shown via wrapper');
      }

      // if (window.chatbot) {
      //   if (typeof window.chatbot.show === 'function') {
      //     window.chatbot.show();
      //   } else if (typeof window.chatbot.open === 'function') {
      //     window.chatbot.open();
      //   }
      // }

      // if (window.ShopDevChatbot) {
      //   if (typeof window.ShopDevChatbot.show === 'function') {
      //     window.ShopDevChatbot.show();
      //   }
      // }

      currentChatbotState.current = true;
    } catch (error) {
      console.error('Error showing chatbot:', error);
    }
  };

  const reinitializeChatbot = () => {
    try {
      // If chatbot wrapper doesn't exist, the script might need to be reloaded
      const chatbotWrapper = document.querySelector('#chatbot-wrapper');
      if (!chatbotWrapper && window.location.pathname.includes('/deal')) {
        // Force script reload by removing and re-adding
        const existingScript = document.querySelector(
          'script[src*="chatbot-loader.js"]',
        );
        if (existingScript) {
          existingScript.remove();

          // Re-add script after a short delay
          setTimeout(() => {
            const script = document.createElement('script');
            script.src = `https://webaibot.devwowcher.co.uk/chatbot-loader.js?containerId=${
              CHATBOT_CONFIG.containerId
            }&t=${Date.now()}`;
            script.async = true;
            document.head.appendChild(script);
          }, 100);
        }
      }
    } catch (error) {
      console.error('Error reinitializing chatbot:', error);
    }
  };

  // Handle route changes
  useEffect(() => {
    const shouldShow = checkChatbotVisibility();
    setShouldShowChatbot(shouldShow);

    if (shouldShow && !currentChatbotState.current) {
      // Should show but currently hidden
      setTimeout(() => {
        showChatbot();
        if (!document.querySelector('#chatbot-wrapper')) {
          reinitializeChatbot();
        }
      }, 500); // Give page time to load
    } else if (!shouldShow && currentChatbotState.current) {
      // Should hide but currently shown
      hideChatbot();
    }
  }, [router.asPath, router.pathname]);

  // Cleanup on unmount
  useEffect(() => {
    const shouldShow = checkChatbotVisibility();
    setTimeout(() => {
      if (!shouldShow) hideChatbot();
    }, 250);

    return () => {
      if (currentChatbotState.current) {
        hideChatbot();
      }
    };
  }, []);

  return (
    <div
      className="shop-dev-container"
      id={CHATBOT_CONFIG.containerId}
      style={{
        height: '0px',
        position: 'relative',
        width: '100%',
        zIndex: 1_000,
      }}
    />
  );
};

export default ChatbotContainer;
